module.exports = __webpack_public_path__ + "ViasatSportFI-8292a4893a1fd59da5ebe2be49512590.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/ViasatSportFI.jpg
// module id = 1151
// module chunks = 0 1